<table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp monitoring-table">
    <thead>
        <tr>
            <th style="width: 5%" class="header-cell">#</th>
            <th style="width: 10%" class="header-cell">Id</th>
            <th style="width: 40%" class="header-cell">Gridics Id</th>
            <th style="width: 15%" class="header-cell">Group Id</th>
            <th style="width: 15%" class="header-cell">Created</th>
            <th style="width: 15%" class="header-cell">Duration</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let prThreadData of prThreadsData; let i = index" app-pr-thread-row [prThreadData]="prThreadData"
            [index]="i+1"></tr>
    </tbody>
</table>
